/* Native bundle parents own their included gifts. Legacy products keep form-scoped gifts. */
(() => {
  const parentVariantIds = new Set(["64508046508409", "64508133540217", "64508192850297", "57245852205433", "64508209070457", "64508216213881", "64946482315641", "64946491392377", "64946498077049", "64946506662265", "64946526781817", "64946546901369"]);
  const parentProductIds = new Set(["15769227035001", "15769243582841", "15769257050489", "15499532239225", "15769262391673", "15769265144185", "15884962431353", "15884964823417", "15884966396281", "15884968493433", "15884970197369", "15884971835769"]);
  const forms = new WeakMap();
  const isVariant = id => parentVariantIds.has(String(id));
  const isNativeLine = item => !!item && (isVariant(item.variant_id || item.id) ||
    parentProductIds.has(String(item.product_id)) || item.has_components === true || !!item.parent_relationship);

  function findForm(root, id) {
    return Array.from(root.querySelectorAll('form')).find(form => form.getAttribute('id') === id) || null;
  }

  function init(root = document) {
    root.querySelectorAll('[data-dreaver-gift-form]').forEach(node => {
      const form = findForm(root, node.dataset.dreaverGiftForm);
      if (!form) return;
      try {
        const config = JSON.parse(node.textContent);
        forms.set(form, { ...(forms.get(form) || {}), gifts: config.gifts || [], productId: config.productId });
      } catch (error) {
        console.error('[Dreaver gifts] Invalid form configuration', error);
      }
    });
    root.querySelectorAll('[data-additional-product-id][data-form]').forEach(node => {
      const form = findForm(root, node.dataset.form);
      if (form) forms.set(form, { ...(forms.get(form) || {}), upsell: node });
    });
  }

  function primaryVariant(data) {
    return data.get('items[0][id]') || data.get('id');
  }

  // Only remove auto-gifts explicitly linked to a native parent in this request.
  // Keep user-selected accessories and gifts belonging to legacy lines in mixed adds.
  function removeLinkedNativeGifts(data) {
    const groups = new Map();
    for (const [key, value] of data.entries()) {
      const match = /^items\[(\d+)\](.*)$/.exec(key);
      if (!match) continue;
      if (!groups.has(match[1])) groups.set(match[1], {});
      groups.get(match[1])[match[2]] = value;
    }
    const nativeIds = new Set(Array.from(groups.values()).filter(item => isVariant(item['[id]'])).map(item => String(item['[id]'])));
    if (isVariant(data.get('id'))) nativeIds.add(String(data.get('id')));
    const remove = new Set(Array.from(groups.entries()).filter(([, item]) =>
      item['[properties][_free_gift]'] === 'true' && nativeIds.has(String(item['[properties][_trigger_variant_id]']))
    ).map(([index]) => index));
    if (!remove.size) return;
    const retained = Array.from(groups.keys()).filter(index => !remove.has(index)).sort((a, b) => Number(a) - Number(b));
    const values = Array.from(data.entries());
    for (const key of Array.from(new Set(values.map(([key]) => key)))) {
      if (/^items\[\d+\]/.test(key)) data.delete(key);
    }
    values.forEach(([key, value]) => {
      const match = /^items\[(\d+)\](.*)$/.exec(key);
      if (match && !remove.has(match[1])) data.append(`items[${retained.indexOf(match[1])}]${match[2]}`, value);
    });
  }

  function prepareFormData(data, form) {
    init(form.closest?.('quick-buy-drawer') || document);
    removeLinkedNativeGifts(data);
    const config = forms.get(form);
    const variantId = primaryVariant(data);
    if (!config || !variantId || data.has('items[0][id]')) return;
    const nativeParent = isVariant(variantId) || parentProductIds.has(String(config.productId));
    const gifts = nativeParent ? [] : Array.from(new Set((config.gifts || []).map(String))).filter(id => id && id !== String(variantId));
    const upsell = config.upsell?.querySelector('input[type="checkbox"]')?.checked ? config.upsell.dataset.additionalProductId : null;
    if (!gifts.length && !upsell) return;
    const quantity = data.get('quantity') || '1';
    data.delete('id');
    data.delete('quantity');
    data.set('items[0][id]', variantId);
    data.set('items[0][quantity]', quantity);
    // Keep line properties and selling plans attached to the original main item.
    for (const [key, value] of Array.from(data.entries())) {
      if (key.startsWith('properties[')) {
        data.delete(key);
        data.append(`items[0][properties]${key.slice('properties'.length)}`, value);
      } else if (key === 'selling_plan') {
        data.delete(key);
        data.set('items[0][selling_plan]', value);
      }
    }
    let index = 1;
    gifts.forEach(id => {
      data.set(`items[${index}][id]`, id);
      data.set(`items[${index}][quantity]`, '1');
      data.set(`items[${index}][properties][_free_gift]`, 'true');
      data.set(`items[${index}][properties][_trigger_variant_id]`, String(variantId));
      index += 1;
    });
    if (upsell && String(upsell) !== String(variantId)) {
      data.set(`items[${index}][id]`, upsell);
      data.set(`items[${index}][quantity]`, '1');
    }
  }

  window.DreaverBundleGifts = { init, isVariant, isNativeLine, prepareFormData, primaryVariant, removeLinkedNativeGifts };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
